import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { ProductService } from 'src/app/services/product/product.service';
import { Productcategory } from 'src/app/model/productcategory.model';
import { OrderService } from 'src/app/services/order/order.service';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent implements OnInit {

  //product: Products;
  product: any;
  productCopy : any;
  category: Productcategory;
  cartItems: any;
  filteredProduct: any;

  isListView : boolean = false;
  isCompactView : boolean = false;
  isTilesView : boolean = false;

  constructor(private productServices: ProductService, private orderServices: OrderService) {

  }



  ngOnInit() {

    this.isTilesView = true;
    this.getProductList();
    this.getProductCategory();
    this.getCartItems();
  }

  getProductCategory() {
    this.productServices.getProductCategory().subscribe(
      (data: any) => {
        this.category = data;
        console.log(this.category);
      }
    )
  }

  getProductList() {
    this.productServices.getProductListForOrder().subscribe(
      (data: any) => {
        this.product = data;
        this.productCopy = data;
        console.log(this.product);
      }
    )
  }

  addtocart(productId: number) {
    this.orderServices.addToCart(productId).subscribe(
      (data: any) => {
        if (data == true) {
          //alert("added");
          debugger;
          this.getCartItems();
          window.scrollTo(0, 0);
          //this.getCartItems();
        }
        else {
          alert("already added");
        }
      }
    )
  }

  showAllProduct()
  {
    alert("shown");
  }

  getCartItems() {
    this.orderServices.getUserCartItems().subscribe(
      (data: any) => {
        this.cartItems = data;
        console.log(this.cartItems);
      }
    )
  }

  onSelectCategory(catid) {
    
    this.filteredProduct = this.productCopy.filter(x => x.productCategoryId == catid);
    this.product = this.filteredProduct;
    // if (this.productData != null) {
    //   this.product.productName = this.productData.name;
    //   this.product.unitsPerCase = this.productData.mpSalesPerCase;
    //   this.product.productDescription = this.productData.mpPackSizeCode;

    // }
    // console.log(this.productData);

  }

  filterProductList(keyword)
  {
    this.productServices.filterProduct(keyword).subscribe(
      (data) => {
        this.product = data;
        console.log(data);
      }
    );
    //alert(keyword);
  }

  displayListView()
  {
    //alert("Displaying List View");
    this.isListView = true;
    this.isCompactView = false;
    this.isTilesView = false;
  }

  displayCompactView()
  {
    //alert("Displaying Compact View");
    this.isListView = false;
    this.isCompactView = true;
    this.isTilesView = false;
  }

  displayTilesView()
  {
    //alert("Displaying Tiles View");
    this.isListView = false;
    this.isCompactView = false;
    this.isTilesView = true;
  }

}
